import { getCurrentIntl } from 'i18n/util/currentIntl'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'

export function getOccupancyText(rooms: Array<App.Occupants>, saleUnit?: string) {
  const intl = getCurrentIntl()
  let text = formatOccupantsShort(rooms)
  if (!!saleUnit && !!rooms.length) {
    text = intl.formatMessage(
      {
        id: 'BZOFc8YOUdbpWaSFHEjF',
        defaultMessage: '{occupancyText} · {saleUnitLabel}',
        description: 'Occupancy text joined with sale unit count for the recommendation card display',
      },
      {
        occupancyText: text,
        saleUnitLabel: intl.formatMessage({
          id: '15lMPlOYhxxE7aKBpdTO',
          defaultMessage: '{count, plural, one {# room} other {# rooms}}',
          description: 'Pluralized sale unit count for recommendation occupancy',
        }, { count: rooms.length }),
      },
    )
  }
  return text
}
